import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import React from 'react';
import { useFormikContext } from 'formik';

export const CancelOrSubmit: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { isValid } = useFormikContext();
  return (
    <div className={'fa-pull-right ml-auto'}>
      <ButtonTW className={'mr-2'} secondary={true} onClick={onClose}>
        Cancel
      </ButtonTW>
      <ButtonTW type={'submit'} disabled={!isValid}>
        Save
      </ButtonTW>
    </div>
  );
};
